import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { serverURL } from '../config/urls';
import "../styles/navbar.css";
import {useUserProfile} from "./user-profile-context";
function NavBar() {
    const [isNavExpanded, setIsNavExpanded] = useState(false);
    const [isAuthenticated, setIsAuthenticated] = useState(true);
    const [inCareerMode, setInCareerMode] = useState(false);
    const {userProfile} = useUserProfile();
    const navigate = useNavigate();
    
    const imgSrc = isNavExpanded
        ? inCareerMode
        ? require('../img/close-light.png')
        : require('../img/close.png')
        : inCareerMode
        ? require('../img/hamburger-light.png')
        : require('../img/hamburger.png');

    function toggleNav() {
        if (!isNavExpanded) {
            document.body.style.overflow = 'hidden';
            setIsNavExpanded(true);
        }
        else {
            document.body.style.overflow = 'auto';
            setIsNavExpanded(false);
        }
    }

    function handleLogout() {
        localStorage.removeItem('token');
        window.location.reload();
    }

    useEffect(() => {
        // fetch(serverURL + '/auth/check', {
        //     headers: {
        //         'Authorization': `Bearer ${localStorage.getItem('token')}`
        //     }
        // })
        //     .then(response => response.json())
        //     .then(data => {
        //         setInCareerMode(window.location.href.includes('/career/'));
        //         setIsAuthenticated(data.isAuthenticated);
        //     })
        //     .catch(err => {
        //         setIsAuthenticated(false);
        //     })
    }, [navigate]);
    return (
        <div className='navbar wrapper' style={{backgroundColor: inCareerMode ? "#475B5A" : "inherit"}}>
            <div className={isNavExpanded ? 'navbar-container responsive row' : 'navbar-container row'}>
                <div className='row'>
                    <Link to="/" className='row'><img className='logo' src={require("../img/logo.png")} alt="" /><h2 className='brand'>Career Sample</h2></Link>
                    {
                        (isAuthenticated && userProfile.isPremium) ? 
                        <p className='beta-tag' style={{background: "antiquewhite"}}>Premium</p> :
                        <p className='beta-tag'>Beta</p>
                    }
                </div>
                <div className='menu-items row'>
                    <div className='item-container row'>
                        {isAuthenticated && <Link to="/careers" className={`link ${inCareerMode ? 'white' : 'black'}`}>Careers</Link>}
                        <Link to="/recommended" className={`link ${inCareerMode ? 'white' : 'black'}`}>Chatbot</Link>
                        {isAuthenticated && <Link to="/contribute" className={`link ${inCareerMode ? 'white' : 'black'}`}>Contribute</Link>}
                    </div>
                    <div className='item-container row'>
                        {/* {isAuthenticated && <button onClick={handleLogout} className='signup-btn'>Log Out</button>} */}
                        {!isAuthenticated && <a href="/signin" className='link signin black' style={{ textTransform: "none", cursor: 'pointer' }}>Sign In</a>}
                        {!isAuthenticated && <a href="/signup"><button className='signup-btn'>Sign Up</button></a>}
                    </div>
                </div>
                <img onClick={toggleNav} alt="" className='expand-btn' src={imgSrc} />
            </div>
            {
                isNavExpanded &&
                <div className='expanded-items col' style={{backgroundColor: inCareerMode ? "rgb(71, 91, 90)" : "white"}}>
                    {
                        isAuthenticated ? 
                        <div className='col center container'>
                            <a href="/careers" className='link' style={{color: inCareerMode ? "white" : "black"}}>Careers</a>
                            <a href="/recommended" className='link' style={{color: inCareerMode ? "white" : "black"}}>Chatbot</a>
                            <a href="/contribute" className='link' style={{color: inCareerMode ? "white" : "black"}}>Contribute</a>
                            {/* <button onClick={handleLogout} className='secondary-btn'>Log Out</button> */}
                        </div> : 
                        <div className='col center container'>
                            {/* <button className='primary-btn' onClick={()=>window.location.href="/signin"}>Sign In</button>
                            <button className='secondary-btn' onClick={()=>window.location.href="/signup"}>Sign Up</button> */}
                        </div>
                    }
                    
                </div>
            }
        </div>

    );
}

export default NavBar;